import {Injectable} from '@angular/core';
import {doc, Firestore, getDoc} from '@angular/fire/firestore';

@Injectable({
  providedIn: 'root',
})
export class CollectionSharedSingularDocumentsService {

  constructor(private firestore: Firestore) {
  }

  async getDocument<DataType>(
    path: string,
  ): Promise<DataType> {
    try {
      const docRef = doc(this.firestore, path);
      const docSnapshot = await getDoc(docRef);
      if (docSnapshot.exists()) {
        return docSnapshot.data() as DataType;
      } else {
        return {} as DataType;
      }
    } catch (error) {
      console.error(error);
    }
  }
}
